import { IMAGE_CHANGE } from '../../action-types/ui/imageChange';

export const STATE_KEY = 'imageChange';

export const imageChange = (state = { isChange: true }, action) => {
  switch (action.type) {
    case IMAGE_CHANGE:
      return Object.assign({}, state, {
        isChange: action.isChange,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/imageChange.js